module.exports = __webpack_public_path__ + "static/img/school-10.2be7732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-10.png
// module id = 2kyd
// module chunks = 1